<template>
  <ContextMenu ref="contextMenu" :nodeClicked="nodeClicked" :nodesSaved="nodesSaved">
    <Canvas ref="canvasComponent" @hideContextMenu="testeventCore()" @canvasClicked="testCanvasClicked()"/>
  </ContextMenu>
</template>

<script>
import ContextMenu from "../components/Core/ContextMenu";
import Canvas from "../components/Core/Canvas";
import {mapActions, mapState} from "vuex";
import authMixin from '../mixins/authMixins';
export default {
  name: "home",
  data() {
    return {
      nodeClicked : true,
      nodesSaved: [],
    }
  },
  components: {
    ContextMenu,
    Canvas,
  },

  async beforeMount() {
    // Check if the project id is not null
    await authMixin.methods.checkToken(this.$http, this.$router, { name: 'Core' });
    this.currentProject = this.$route.params.id;
    // this.$http.get(`/projects/${this.$route.params.id}/skills/`).then(({ data }) => {
    //   this.skillId = data[0]._id;
    //   this.$router.push({
    //     path: `/projects/5f9934dea25c715d7f9a663c/skills/${this.skillId}`,
    //   });
    // });

    this.breadcrumbs = [
      {
        text: "Projects",
        disabled: false,
        to: "/projects",
        link: true,
        exact: true,
      },
      {
        text: this.$route.params.id,
        disabled: false,
        to: `/projects/${this.$route.params.id}`,
        link: true,
        exact: true,
      },
      {
        text: "Skills",
        disabled: false,
        to: `/projects/${this.$route.params.id}/skills`,
        link: true,
        exact: true,
      },
      {
        text: this.skillId,
        disabled: true,
      },
    ];
  },
  mounted() {

  },
  watch: {
    // Cette fonction s'exécute chaque fois que `currentNodes` change
    currentNodes: {
      immediate: true,
      handler(newValue) {
        // Vérifiez si newValue (la nouvelle valeur de `currentNodes`) existe
        if (newValue) {
          this.fetchAndPrepareSavedNodes();
        }
      }
    }
  },
  computed : {
    ...mapState('httpNodes', ['currentNodes'])
  },
  methods: {
    ...mapActions({
      getSavedNodes: "http/nodes/getSavedNodes",
      getSkills: "http/skills/get",
    }),
    testeventCore() {
      this.nodeClicked = false;
    },
    testCanvasClicked() {
      if(!this.nodeClicked){
        this.nodeClicked = true;
      }
    },

    addItems(nodes) {
      nodes.map(node => {
        if (node) {
          this.nodesSaved.push(
              {
                title: node.name,
                icon: "mdi-plus",
                action: node,
              }
          );
        }
      });
    },

    filterAndMapSavedNodes(nodes) {
      return nodes.filter((data) => data.isSaved === true);
    },

    fetchAndPrepareSavedNodes() {
      if(this.currentNodes) {
        const savedNodes = this.filterAndMapSavedNodes(this.currentNodes);
        if (savedNodes.length > 0) {
          this.addItems(savedNodes);
        }
      }
    },
  }
};
</script>

<style>
main {
  height: 100vh !important;
  max-height: 100vh !important;
}
</style>
